import { skipToken } from '@reduxjs/toolkit/query';
import Loader from 'components/Loader';
import { useParams } from 'react-router-dom';
import { useGetTaskByIdQuery } from 'store/api/tasks';
import TaskPageView from './TaskPageView';

const TaskPage = (): JSX.Element => {
    const { id: taskId } = useParams();
    // Errors surface via the global rtkQueryErrorHandler (404/403 redirect, toast otherwise),
    // so on failure render nothing instead of an everlasting loader.
    // Read afresh: a draft completed in its form opens here, where the form's read of the draft may still be cached.
    const { data: task, isError } = useGetTaskByIdQuery(taskId ?? skipToken, { refetchOnMountOrArgChange: true });

    if (task === undefined) {
        return isError ? <></> : <Loader />;
    }

    return <TaskPageView task={task} />;
};

export default TaskPage;
